import type * as ents from '@attain-apps/entities'

import type * as ecModels from '../../../models'

import type { Plugin } from './plugin'

// TODO: implement needed selectors from below
export class Selectors<TTypeParams extends ecModels.TypeParams.Constraint> {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly attributes
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly visibleAttributes
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly hiddenAttributes
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getAttribute
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly isLoading
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin<TTypeParams>) {
    this.attributes = plugin.feature.state.project(
      state => state.attributes ?? [],
    )
    this.visibleAttributes = this.attributes.project(attributes =>
      attributes.filter(attribute => !attribute.isHidden),
    )
    this.hiddenAttributes = this.attributes.project(attributes =>
      attributes.filter(attribute => !!attribute.isHidden),
    )
    this.getAttribute = plugin.feature.createSelectorMethod(
      (id: ents.core.common.Attribute.Id) =>
        this.attributes.project(attributes =>
          attributes.find(attribute => attribute.id === id),
        ).asSelector,
    )

    this.isLoading = plugin.feature.state.project(state => state.isLoading)
    this.error = plugin.feature.state.project(state => state.error)
  }
}
